/** Check if element is visible in browser view port */
export function useIsElementInView(element: HTMLElement) {
  const bounding = element.getBoundingClientRect()

  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

/** Vertical (block) overflow */

/** check if an element is currently scrollable */
export function useIsScrollableBlock(element: HTMLElement) {
  return element && element.clientHeight < element.scrollHeight
}

/**
 * Ensure a given child element is within the parent's visible scroll area.
 * If the child is not visible, scroll the parent
 */
export function useMaintainScrollVisibilityBlock(
  activeElement: HTMLElement,
  scrollParent: HTMLElement,
) {
  const { offsetHeight, offsetTop } = activeElement
  const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent

  const isAbove = offsetTop < scrollTop
  const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight

  if (isAbove) {
    scrollParent.scrollTo(0, offsetTop)
  } else if (isBelow) {
    scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight)
  }
}

/** Horizontal (inline) overflow */

/** check if an element is currently scrollable */
export function useIsScrollableInline(element: HTMLElement) {
  return element && element.clientWidth < element.scrollWidth
}

/**
 * Ensure a given child element is within the parent's visible scroll area.
 * If the child is not visible, scroll the parent
 */
export function useMaintainScrollVisibilityInline(
  activeElement: HTMLElement,
  scrollParent: HTMLElement,
) {
  const { offsetWidth, offsetLeft } = activeElement
  const { offsetWidth: parentOffsetWidth, scrollLeft } = scrollParent

  const isAbove = offsetLeft < scrollLeft
  const isBelow = offsetLeft + offsetWidth > scrollLeft + parentOffsetWidth

  if (isAbove) {
    scrollParent.scrollTo(offsetLeft, 0)
  } else if (isBelow) {
    scrollParent.scrollTo(offsetLeft - parentOffsetWidth + offsetWidth, 0)
  }
}
